import { FeatureIdentifier } from '../enums/feature-identifier.enum';
import { ModuleTestStatus } from '../enums/module-test-status.enum';
import { Status } from '../enums/status.enum';
import { SubscriptionStatus } from '../enums/subscription-status.enum';
import { UtilHelper } from '../helpers/utils.helper';
import { FeatureInTest } from './feature-in-test.model';
import { SubscriptionModule } from './subscription.model';

export class Plan {
  id: number;
  name: string;
  desc: string;
  price: number;
  order: number;
  originalPrice: number;
  status: Status;
  visible: boolean;
  modules: Array<Module>;
  planIdentifier: string;
  featureIdentifiers: FeatureIdentifier;
  intern: boolean;
  interval: number;

  // aux front
  mainModules: Array<Module> = [];
  extraModules: Array<Module> = [];
  subtotal: number;
  discount: number;
  total: number;
  period: string;
  valuePerMonth: number;
  totalWithInTestModules: number;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.status != null && this.status['code'] == null) {
      this.status = UtilHelper.getEnumByCod(this.status, Status);
    }
    if (this.modules && this.modules.length > 0) {
      this.extraModules = this.modules
        .filter((m: Module) => m.extra && m.visible)
        .map((m) => new Module(m));
      this.mainModules = this.modules
        .filter((m: Module) => !m.extra && m.visible)
        .slice(0, 3)
        .map((m) => new Module(m));
    }
    if (this.intern) {
      this.subtotal = 0;
      this.total = 0;
    } else {
      this.subtotal = this.price;
      this.total = this.price;
    }
    if (this.interval == 12) {
      this.period = 'SUBSCRIPTION.YEAR';
    } else {
      this.period = 'SUBSCRIPTION.MONTH';
    }

    if (!this.interval) this.interval = 1;
    this.valuePerMonth = this.price / this.interval;
    this.discount = 0;
  }

  prepareSubscriptionModules(storeFeatures: FeatureInTest[], currentModules: SubscriptionModule[]) {
    console.log(storeFeatures);
    if (currentModules && currentModules.length > 0) {
      // Para garantir que no plano atual apareça apenas os módulos dele, mais os atuais, mesmo que não visiveis mais
      // 1. Filtra todos os modulos q nao estao na assinatura por feature
      this.extraModules = this.extraModules.filter((m) => {
        return (
          currentModules.find((sm) => sm.modules.featureIdentifiers == m.featureIdentifiers) == null
        );
      });
      // 2. Adiciona os módulos que estao na assinatura
      this.extraModules = currentModules
        .map((sm) => new Module(sm.modules))
        .concat(this.extraModules);
    }

    if (this.extraModules && this.extraModules.length > 0) {
      this.extraModules.forEach((m) => {
        m.selected = false;
        const storeModule: FeatureInTest = storeFeatures.find(
          (f) => f.identifiers == m.featureIdentifiers
        );
        if (storeModule) {
          switch (storeModule.status) {
            case SubscriptionStatus.ACTIVE:
              m.selected = true;
              m.situation = ModuleTestStatus.SUBSCRIBED;
              break;

            case SubscriptionStatus.IN_TEST:
              m.situation = ModuleTestStatus.IN_TEST;
              m.testEndDate = storeModule.endDate;
              break;

            case SubscriptionStatus.TRIAL_EXPIRED:
              m.situation = ModuleTestStatus.TRIAL_EXPIRED;
              m.testEndDate = storeModule.endDate;
              break;

            default:
              break;
          }
        } else {
          m.situation = ModuleTestStatus.AVAILABLE_FOR_TEST;
        }
      });
    }
    this.extraModules.sort((m1, m2) => {
      return m1.order > m2.order ? 1 : -1;
    });
  }

  getSelectedModulesId(): number[] {
    return this.extraModules.filter((m) => m.selected).map((m) => m.id);
  }
}

export class Module {
  id: number;
  desc: string;
  details: string;
  price: number;
  order: number;
  originalPrice: number;
  extra: boolean;
  visible: boolean;
  featureIdentifiers: FeatureIdentifier;

  // aux front
  selected: boolean;
  situation: ModuleTestStatus;
  testEndDate: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);
  }

  link(): string {
    switch (this.featureIdentifiers) {
      case FeatureIdentifier.MENU:
        return 'https://fastget.com.br/cardapio-digital';

      case FeatureIdentifier.FULL_ORDER:
        return 'https://fastget.com.br/delivery';

      case FeatureIdentifier.BOOKING_TABLE:
        return 'https://fastget.com.br/reservas-de-mesa';

      case FeatureIdentifier.QUEUE:
        return 'https://fastget.com.br/fila-de-espera';

      case FeatureIdentifier.MULTI_LANG:
        return 'https://fastget.com.br/cardapio-varios-idiomas';

      default:
        return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/plan.model.ts